module.exports = __webpack_public_path__ + "static/img/homeBig.48c8f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homeBig.png
// module id = uVFB
// module chunks = 0